import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import DifmOrderFormSummaryItem from './difm-order-form-summary-item';
import TextParagraphCollapser from './text-paragraph-collapser';

const { Stack, Divider } = designSystem;

function DifmOrderFormSummarySection({ captions, summaryData, isDesktopView, onEditButtonClick }) {
  return (
    <Stack gap="spacing-4-xs">
      {summaryData.map(({ id, title, value, stepId }, index) => (
        <Fragment key={id}>
          <DifmOrderFormSummaryItem
            title={title}
            buttonLabel={captions.editButtonLabel}
            isDesktopView={isDesktopView}
            onClick={() => onEditButtonClick(stepId, id)}
          >
            <TextParagraphCollapser
              text={value}
              showTitle={captions.showDescriptionTitle}
              collapseTitle={captions.collapseDescriptionTitle}
            />
          </DifmOrderFormSummaryItem>
          {index !== summaryData.length - 1 && <Divider />}
        </Fragment>
      ))}
    </Stack>
  );
}

DifmOrderFormSummarySection.propTypes = {
  captions: PropTypes.shape().isRequired,
  summaryData: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      stepId: PropTypes.string,
    })
  ).isRequired,
  isDesktopView: PropTypes.bool.isRequired,
  onEditButtonClick: PropTypes.func.isRequired,
};

export default DifmOrderFormSummarySection;
